import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '../../shared/pagination.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';

import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';

import { StockReplenishmentTemplateFilterCategoryModel } from '../../../../../../models/aggregates/erp/stock/stock-replenishment-template-filter-category.model';


@Injectable({ providedIn: 'root' })
export class StockReplenishmentTemplateFilterCategoryService extends BaseApiTemplateService<StockReplenishmentTemplateFilterCategoryModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/inv-stock-replenishment-template-filter-categories/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/inv-stock-replenishment-template-filter-categories/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/inv-stock-replenishment-template-filter-categories/backoffice-ep';
    this.httpClient = theHttp;
  }

}
